export default "__VITE_ASSET__331bf485__"